import React, { useState } from "react"
import { useQuery } from "react-query"
import { Container, Row, Col, Card, CardBody } from "reactstrap"
//Import Breadcrumb
import Breadcrumbs from "../../../components/Common/Breadcrumb"
// import abiaStateLogo from "../../../../src/assets/images/states/Abia_State_Logo.png"
import { GENERAL } from "../../../api/general"
import { data } from "common/data/states"
//i18n
import { withTranslation } from "react-i18next"
import { Link } from "react-router-dom"
import { useParams } from 'react-router';
const ApprovedNIMCSupervisorsByLga = (props, route) => {
  const params= useParams()
  // console.log("params :; ", params)
  const [records, setRecords] = useState([])
  const getApprovedNimcRecordsByStateId = useQuery({
    queryKey: ["getApprovedNimcRecordsByStateId"],
    queryFn: () => {
      return GENERAL.getApprovedNimcRecordsByStateId(params?.id)
    },
    onSuccess: async res => {
      console.log("approved nimc agents applicants by state_id ::", res?.data?.palliative)
      // const fixedWallets = res.result
      setRecords(res?.data?.palliative?.sort((a, b) => a.name.localeCompare(b.name)))
    },
  })
  //meta title
  document.title = "Agents Registration - eRecruitement";
  function getItemByName(arr, name) {
    return arr.find(item => String(item.name).toLowerCase() === name)?.logo;
  }

  return (
    <React.Fragment>
      <div className="page-content">
        <Container fluid>
          {/* Render Breadcrumb */}
          <Row>
            <Breadcrumbs
              title={props.t("Approved NIMC Supervisors")}
              breadcrumbItem={props.t("Approved NIMC Supervisors By LGA")}
              hasBackBtn={true}
            />
          </Row>

          <Row>
            {records?.map((item, key) => (
              <Col key={"_col_" + key} md="3">
                <Card className="mini-stats-wid">
                  <CardBody
                    style={{
                      paddingTop: 40,
                      paddingBottom: 40,
                      paddingLeft: 10,
                      paddingRight: 10,
                    }}
                  >
                    <div className="text-center mb-4">
                      <img
                        src={getItemByName(data, String(params?.state).toLowerCase())}
                        width={100}
                        height={100}
                        style={{ textAlign: "center" }}
                      />

                      <div className="row justify-content-center mt-3">
                        <div className="col-xl-10">
                          <h4 className="text-primary">{item.name}</h4>
                        </div>
                      </div>
                    </div>

                    <hr />
                    <Row
                      style={{
                        display: "flex",
                        flexDirection: "row",
                        justifyContent: "space-between",
                      }}
                    >
                      <Col md="5">
                        <Row>
                          <h5
                            style={{
                              textAlign: "center",
                              fontSize: "1rem",
                              fontWeight: "bold",
                              color: "#000",
                            }}
                          >
                            Threshold
                          </h5>
                          <h6
                            style={{
                              textAlign: "center",
                              fontSize: "0.9rem",
                              fontWeight: "500",
                              color: "#000",
                            }}
                          >
                            {item?.threshold?.toLocaleString()}
                          </h6>
                        </Row>
                      </Col>
                      <Col md="7">
                        <Row>
                          <h5
                            style={{
                              textAlign: "center",
                              fontSize: "1rem",
                              fontWeight: "bold",
                              color: "#000",
                            }}
                          >
                            Total Applications
                          </h5>
                          <h6
                            style={{
                              textAlign: "center",
                              fontSize: "0.9rem",
                              fontWeight: "500",
                              color: "#000",
                            }}
                          >
                            {item?.approvedUserCount?.toLocaleString()}
                          </h6>
                        </Row>
                      </Col>
                    </Row>
                    <hr />

                    <Row
                      style={{
                        display: "flex",
                        flexDirection: "row",
                        justifyContent: "space-between",
                      }}
                    >
                      <Col>
                        <h5
                          style={{
                            textAlign: "center",
                            fontSize: "0.9rem",
                            fontWeight: "500",
                            color: "#000",
                          }}
                        >
                          <Link to={`/view-approved-nimc-supervisors-by-lga/${item.id}`}>
                          View Supervisors
                          </Link>
                        </h5>
                      </Col>
                    </Row>
                  </CardBody>
                </Card>
              </Col>
            ))}
          </Row>
        </Container>
      </div>
    </React.Fragment>
  )
}

export default withTranslation()(ApprovedNIMCSupervisorsByLga)
